import { motion, useReducedMotion } from "framer-motion";

const WORDS = [
  "MEDICAL",
  "+",
  "EQUAL",
  "+",
  "CARE",
  "—",
  "A licensed clinical pathway",
  "—",
  "Focused market partnerships",
  "—",
];

export default function EditorialMarquee() {
  const reduced = useReducedMotion();
  const track = Array(2).fill(WORDS).flat();

  return (
    <section
      data-testid="editorial-marquee"
      className="bg-[#f4f0e6] text-[#0a1930] overflow-hidden border-y border-[#0a1930]/15"
      aria-label="Medicual editorial marquee"
    >
      <div className="py-10 sm:py-14 lg:py-24">
        <div
          className={`flex whitespace-nowrap ${
            reduced ? "" : "marquee-track"
          }`}
          style={{ width: "max-content" }}
        >
          {track.map((w, i) => (
            <span
              key={i}
              className={`font-display text-[clamp(2.35rem,11vw,4.25rem)] sm:text-[clamp(3.5rem,10vw,10rem)] leading-none tracking-[-0.03em] px-4 sm:px-8 ${
                w === "+"
                  ? "text-[#f26522] font-display-italic"
                  : w === "—"
                  ? "opacity-30"
                  : ""
              }`}
            >
              {w}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
